/**
 * Copyright (c) Qwoach LLC 2020. All rights reserved.
 * Unauthorized copying of this file, via any medium is strictly prohibited
 * Proprietary and confidential
 * Created by Artem Bogush on 7/9/20
 *
 */
import BaseObject from "@shared/BaseObject";
import {addScript, isScripExist, waitFor} from "@/utils/helpers";
import QwoachDataManager from "@/core/js/backend/QwoachDataManager";

export default class PaymentSdkManager extends BaseObject {

	static paypalScriptLoaded = false
	static paypalScriptFailed = false
	static stripeScriptLoaded = false
	static stripeScriptFailed = false
	static stripe
	dataManager: QwoachDataManager = null

	stripeSdkLink = "https://js.stripe.com/v3/"

	constructor(dataManager, coachId) {
		super();
		this.dataManager = dataManager
		this.coachId = coachId || dataManager.ownerId
	}

	async loadPayPalSdk(){

		let scriptId = "payPalSdk"
		if(!PaymentSdkManager.paypalScriptLoaded && !isScripExist(scriptId)){
			PaymentSdkManager.paypalScriptLoaded = true
			try{
				let payPalSdkLink = await this.dataManager.apiPostPayPalPaymentLink({coachId: this.coachId})
				await addScript(payPalSdkLink, scriptId)
			} catch (e) {
				PaymentSdkManager.paypalScriptFailed = true
				throw e
			}
		}
		await waitFor(_ => window.paypal != null || PaymentSdkManager.paypalScriptFailed)
		return window.paypal
	}

	async loadStripeSdk(){

		let scriptId = "stripeSdk"
		if(!PaymentSdkManager.stripeScriptLoaded && !isScripExist(scriptId)){
			PaymentSdkManager.stripeScriptLoaded = true
			try{
				await addScript(this.stripeSdkLink, scriptId)
				let {stripeAccountId, stripeApiKey} = await this.dataManager.apiGetStripeApiKey({coachId: this.coachId})
				await waitFor(_ => window.Stripe != null || PaymentSdkManager.stripeScriptFailed)
				PaymentSdkManager.stripe = window.Stripe(stripeApiKey, {stripeAccount: stripeAccountId})
				console.log("loaded")
			} catch (error) {
				console.error(error)
				PaymentSdkManager.stripeScriptFailed = true
				throw error
			}
		}
		console.log("waited: window.Stripe = ", window.Stripe)

		return PaymentSdkManager.stripe
	}

}
